<div class="card-holder dt anim-group font-noto newUI">
  <ng-container *ngFor="let item of products">
    <div class="card anim-fadeIn tw-bg-transparent" *ngIf="item.price !== 0" (click)="viewProduct(item)">
      <img class="tw-block tw-border tw-border-white tw-border-b-0" #img="" [src]="item?.rebrandedImageWithBackground?.[0] || item?.productUnboxedImage?.[0] || item?.images?.[0]" align="middle" />
      <div class="detail tw-bg-white tw-pt-3 tw-pb-4">
        <div class="name font12 tw-mt-0">{{item.title.substr(0, 25)}}</div>
        <del class="font14 fw-700 pR5">₹{{item.mrp}}</del>
        <span class="clr-orange fw-700">₹{{item.price}}</span>
<!--        Addition and subtraction of product buttons -->
        <div
          class="tw-mt-[5px] tw-h-8 tw-border tw-border-teal-600 tw-rounded-3 tw-flex tw-justify-evenly tw-items-center tw-text-200 tw-font-bold tw-font-body tw-bg-white tw-text-teal-600"
          *ngIf="item?.quantityCart && item?.quantityCart !== 0">
          <em class="cs-icon-minus" (click)='addOrRemoveFromCart(item, "REMOVE", $event, img)'></em>
          <span *ngIf="item?.prescriptionRequired">
           {{item?.quantityCart > rxLimit ? rxLimit : item?.quantityCart}}
          </span>
          <span *ngIf="!item?.prescriptionRequired">
           {{item?.quantityCart > nonRxLimit ? nonRxLimit : item?.quantityCart}}
          </span>

          <em class="cs-icon-plus" (click)='addOrRemoveFromCart(item, "ADD", $event, img)'></em>
        </div>
<!--Add to cart CTA-->
        <div
          *ngIf="(!item?.quantityCart || item?.quantityCart === 0 )" (click)='addOrRemoveFromCart(item, "ADD", $event, img)'
          class="tw-mt-[5px] tw-h-8 tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-1 tw-text-white tw-font-bold tw-text-200 tw-bg-teal-600 tw-rounded-3"
        >
          <span i18n="@@addToCart">Add to Cart</span>
          <cs-icon class="tw-h-5 tw-w-5" [iconName]="'chevron_right'"></cs-icon>
        </div>
      </div>
    </div>
  </ng-container>
</div>
